import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  CardActions,
  CardActionArea,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemLink,
  Grid,
  CardHeader,
  Chip,
  CardMedia,
  IconButton,
  Avatar, 
  Divider
} from '@material-ui/core';

import { LocationOn, Assignment, Group, FormatListNumbered } from '@material-ui/icons';
import {UserCard} from './components';


const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  content: {
    padding: 20,
    margin: 20
  },
  chip: {
    paddingBottom: 10,
    paddingTop: -10
  },
  green: {
    backgroundColor: 'primary',
    color: 'primary',
    justifyContent: 'flex-end'
  },
  image: {
    height: 48,
    width: 48
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));
let usersList;
const Users = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  usersList = props.usersList;
  if(usersList)
    return (
      <Grid
        container
        spacing={5}
      >
        {usersList.map(user => (
          <Grid item>
            <Card>

              <CardContent className={classes.content}>
                <UserCard user={user} />

              </CardContent>

            </Card>
          </Grid>
        ))}
      </Grid>
    );
  else
    return (<Grid></Grid>)

};

Users.propTypes = {
  className: PropTypes.string,
  usersList: PropTypes.array
};

export default Users;
